import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { TelecomProvider } from './telecom-provider.enum';
import { DIDRoutingType } from './did-routing-type.enum';

@Api('api/agentic-cx/inbound-number')
export class InboundNumberDto extends DtoHasApi {
  id?: number;
  phoneNumber!: string;
  provider!: TelecomProvider;
  routingType!: DIDRoutingType;
  ivrInstanceId!: string;
  ivrInstanceName?: string;
  ivrExtension?: string;
  isActive?: boolean;
}
